// Do not use interactive elements inside of a textrotator. It will not work, and is bad for accessibility.

'use strict';
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

/**
 * Textrotator
 * @author Jesse de Vries
 */
function Textrotator(options) {
    this.Init(options);
}
Textrotator.prototype = {
    /**
     * Constructor
     * @Param object options
     * @return void
     */
    // Initialize Object variables
    Init: function (options) { // Initialization
        // Default selectors
        this.options = Object.assign({
            rotators: '.js-textrotator',
            items: '.js-textrotator > *',
        }, options);
        // Initialize Prototype variables
        this.rotators = document.querySelectorAll(this.options.rotators);
        this.items = this.options.items;
        this.Start();
    },

    /**
     * Start
     * @return void
     */
    // Start
    Start: function() {
        const _this = this;
        const rotators = this.rotators;
        const rotatoritems = this.items;

        rotators.forEach(function(rotator) {
            let items = rotator.querySelectorAll(rotatoritems);
            document.fonts.ready.then(() => { //if document.fonts.ready doesn't work, you can instead use a setTimeout (e.g. 1000ms).
                _this.SetRotatorWidth(rotator, items); // should update on window.width
                _this.SetAnimation(rotator, items);
            });
            window.addEventListener('resize', function () {
                _this.SetRotatorWidth(rotator, items);
            });
        });
    },

    /**
     * SetRotatorWidth
     * @return void
     */
    SetRotatorWidth: function(rotator, items) {

        const _this = this;
        let widest = 0;
        let widestItem = null;

        rotator.style.width = 0;

        items.forEach(function (item, index) {
            item.style.position = 'static';
            let width = item.offsetWidth;

            if (width > widest) {
                widest = width;
                widestItem = item;
            }

            if (index === items.length - 1) {
                rotator.style.width = widestItem.offsetWidth + 'px';
                items.forEach(function (item) {
                    item.removeAttribute('style');
                });
            }
        });

    },

    /**
     * SetAnimation
     * @return void
     */
    // Set Animations
    // todo: find a way to present this for prefers-reduced-motion
    SetAnimation: function (rotator, items) {

        const arr = [];
        let duration = rotator.getAttribute('data-speed');
        if (!duration || duration === '') {
            duration = 2000;
        }

        items.forEach(function (item, index) {
            arr.push(item);
        });

        let i = 0;
        items[0].classList.add('active');

        requestAnimationFrame(function() {
            setInterval(function rotateText() {
                items.forEach(function(item) {
                    item.classList.remove('active');
                });
                items[0].classList.remove('is-prev');
                items[i].classList.add('active'); // Uncaught TypeError: Cannot read properties of undefined (reading 'classList')
                if (i === arr.length - 1) {
                    items[0].classList.add('is-prev');
                }
                i = (i + 1) % arr.length;
                return rotateText;
            } (), duration);
        })

    }
}
export { Textrotator };
